import { Chart } from 'primereact/chart';
import React, { useEffect, useState } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { ApiGet } from '../../helper/API/ApiData';
import { diff_hours, handleError, timestampBodyTemplate } from '../../utils/helper';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useNavigate } from 'react-router-dom';

const TrainingDashboard = ({ showChart = true }: { showChart?: boolean }) => {
    const navigate = useNavigate()

    const [totalCount, setTotalCount] = useState({
        "totalTrainingSessions": 0,
        "totalShgTrained": 0,
        "totalIndividualTrained": 0
    });

    const [shgTrainings, setShgTrainings] = useState([])

    useEffect(() => {

        ApiGet(`training/dashboard`)
            .then((res: any) => {
                if (res?.status === 200) {
                    console.log("🚀 ~ .then ~ res.data[0].trainingDetails:", res.data[0].trainingDetails)
                    setTotalCount(res.data[0].trainingDetails)
                }
            })
            .catch((error) => {
                handleError(error)
                return error
            })

        ApiGet(`training`)
            .then((res: any) => {
                if (res && res.status === 200) {
                    if (res && res.data) {
                        setShgTrainings(res.data.slice(0, 5).map((item: any, index: number) => ({
                            ...item,
                            serial: index + 1,
                            duration: diff_hours(new Date(item.end_timestamp), new Date(item.start_timestamp))
                        })))
                    }
                }
            })

    }, [])

    const header = (
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
            <span className="text-xxl text-900 font-bold">Monitor sessions being conducted</span>
        </div>
    );


    const gotoTraining = () => {
        navigate('/shgadmin/trainings')
    }


    return (
        <Container fluid className="p-3">
            <h4 className="page-title">Training Details</h4>
            <Row>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoTraining()}>
                        <Card.Body style={{ backgroundColor: '#609ea2' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-book" style={{ fontSize: '2.5rem', color: '#fff' }}></i>
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of Training Sessions Conducted</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalTrainingSessions}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoTraining()}>
                        <Card.Body style={{ backgroundColor: '#28a745' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-users" style={{ fontSize: '2.5rem', color: '#fff' }}></i>
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of SHG Trained</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalShgTrained}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoTraining()}>
                        <Card.Body style={{ backgroundColor: '#141E46' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-user" style={{ fontSize: '2.5rem', color: '#fff' }}></i>
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of Individuals Trained</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalIndividualTrained}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
            </Row>

            {showChart &&
                <Row className='mt-4 d-flex justify-content-between'>
                    <Col md={12}>
                        <DataTable
                            dataKey="id"
                            value={shgTrainings}
                            header={header}
                            showGridlines={true}
                        >
                            <Column header="#" field="serial"></Column>
                            <Column
                                bodyStyle={{
                                    borderBottomWidth: 1,
                                    borderColor: 'red',
                                    border: '1px solid grey'
                                }}
                                dataType='datetime'
                                body={(rowData) => <p>{timestampBodyTemplate(rowData, "start_timestamp")}</p>}
                                field="start_timestamp"
                                header="Date">
                            </Column>
                            <Column field="name_of_trainer" header="Trainer"></Column>
                            <Column field="name_of_capacity_building_training_topics" header="Topic"></Column>
                            <Column header="Duration" field="duration" body={(rowData) => <p>{rowData.duration} hours</p>}></Column>
                        </DataTable>
                    </Col>
                </Row>
            }

        </Container>
    )
}

export default TrainingDashboard